// extracted by mini-css-extract-plugin
export default {"spindlLogo":"SpindlLogo_spindlLogo__Hxj7y"};